import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axios from "axios";

const initialState = {
    list: [],
    taskHistory: null,
    error: "",
    loading: false,
};

export const deleteTaskStatus = createAsyncThunk(
    "taskHistory/deleteTaskStatus ",
    async (id) => {
        try {
            const resp = await axios({
                method: "delete",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `taskHistory/${id}`,
            });

            toast.success("Task Status Deleted");
            return {
                data: resp.data.id,
                message: "success",
            };
        } catch (error) {
            toast.error("Error in deleting Task Status try again");
            console.log(error.message);
        }
    }
);

export const loadAllTaskHistory = createAsyncThunk(
    "taskHistory/loadAllTaskHistory",
    async () => {
        try {
            const { data } = await axios.get(`taskHistory`);
            return data;
        } catch (error) {
            console.log(error.message);
        }
    }
);


const taskHistorySlice = createSlice({
    name: "taskHistory",
    initialState,
    reducers: {
        clearTaskHistoryStatus: (state) => {
            state.taskHistory = null;
        },
        clearTaskHistoryList: (state) => {
            state.list = [];
        },
    },
    extraReducers: (builder) => {
        // 1) ====== builders for loadAllTaskHistory ======

        builder.addCase(loadAllTaskHistory.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(loadAllTaskHistory.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload;
        });

        builder.addCase(loadAllTaskHistory.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });


        // 4) ====== builders for deleteTaskStatus  ======

        builder.addCase(deleteTaskStatus.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(deleteTaskStatus.fulfilled, (state, action) => {
            state.loading = false;
        });

        builder.addCase(deleteTaskStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });
    },
});

export default taskHistorySlice.reducer;
export const { clearTaskHistoryStatus, clearTaskHistoryList } = taskHistorySlice.actions;
